export const sxStyles = () => ({
  footerSectionsContainer1: {
    display: 'flex',
    alignItems: { xs: 'center', lg: 'flex-start' },
    justifyContent: { xs: 'center', lg: 'flex-start' },
    mb: { xs: 3, lg: 0 },
  },

  logosContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  logoAndContact: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: { xs: 'center', lg: 'flex-start' },
    gap: '12px',
  },

  secondaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: { xs: 'center', lg: 'flex-start' },
  },

  primaryLogoLink: {
    display: 'flex',
    alignItems: 'center',
  },

  primaryLogo: {
    width: { xs: '130px', md: '150px' },
    height: 'auto',
    maxHeight: '70px',
  },

  contactInfo: {
    color: 'rgba(255,255,255,0.75)',
    fontSize: { xs: '12px', md: '13px' },
    lineHeight: 1.5,
  },
});
